import { render, staticRenderFns } from "./Academy_STR.vue?vue&type=template&id=807a8ea2"
import script from "./Academy_STR.vue?vue&type=script&lang=js"
export * from "./Academy_STR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports